// API Base URL - uses environment variable or falls back to localhost for development
export const API_BASE = import.meta.env.VITE_API_BASE_URL || 'http://localhost:8080/api/v1';

// Helper function to create fetch options with proper credentials handling
export const createFetchOptions = (options: RequestInit = {}): RequestInit => {
  const isDevelopment = !import.meta.env.VITE_API_BASE_URL;
  
  return {
    ...options,
    credentials: isDevelopment ? 'include' : 'omit', // Only include credentials in development
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  };
}; 